import { useParams } from "react-router-dom";

import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import { constants } from "../constant/constants";
import { useState, useEffect } from "react";
import BranchDetailComponent from "../component/restaurants/branches/BranchDetailComponent";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import CustomLoader from "../component/menu/CustomLoader";

export default function BranchDetail() {
  const params = useParams();
  const [currentRestaurantId, setCurrentRestaurantId] = useState("");
  const { user, showNotification, setNetworkCall } = useUserStore();

  const [branch, setBranch] = useState({
    branchId: "",
    parentRestaurantId: "",
    restaurantName: "",
    branchName: "",
    status: "",
    latitude: 0.0,
    longitude: 0.0,
    address: "",
    countryCode: "",
    phone: "",
    email: "",
    categories: [],
    openTime: "",
    closeTime: "",
    openDays: [],
    logo: "",
    banner: "",
    offerImage: "",
    images: [],
    vat: "0.00",
    serviceCharge: "0.00",
    isVatIncluded: false,
    paymentOptions: [],
    inventoryType: "",
    webAddress: "",
    socialLink: ""
  });
  const [isBranchLoad, setIsBranchLoad] = useState(false);

  async function getBranchDetails(branchId) {
    if (!Boolean(branchId)) return;
    const token = user.token.token;
    setNetworkCall(true);
    try {
      const res = await ApiService.GET_BRANCH_WITH_ID(branchId, token);

      if (!res || res.code !== 200) {
        setNetworkCall(false);
        showNotification(res.message);
        return;
      }
      const { payload } = res;
      setBranch({ ...payload });
      setNetworkCall(false);
      setIsBranchLoad(true);
    } catch (err) {
      showNotification(err.response.message);
    }
  }

  // restaurant id
  useEffect(() => {
    async function fetchDetailData() {
      if (Boolean(params.branchId)) {
        setCurrentRestaurantId(params.restaurantId);
        await getBranchDetails(params.branchId);
      }
    }
    fetchDetailData();
  }, [params]);

  console.log("___branch____", branch);

  return (
    <section>
      <div className="flex flex-col bg-[#e5e7eb]">
        {/* {contextHolder} */}
        <CustomLoader />
        <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={"T_51_S_51"} />
        <div className="flex flex-row bg-prewhite">
          <SideMenu title={`McDonalds Food Chain`} menu={constants.SUPER_MENU.RESTAURANT} />
          <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
            <div className="flex flex-col w-full">
              <FormHeaderComponent
                title={`Branch Detail`}
                listRoute={`/restaurants/${currentRestaurantId}/details`}
                // listRoute="/restaurants"
              />
              <div className="">
                {isBranchLoad && (
                  <BranchDetailComponent
                    records={{
                      data: branch,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
